<div class="content-block">
  <h2>{{ formatMessage("sidenav.jobs") }}</h2>

  <app-order-grid> </app-order-grid>
</div>
